"use client";

import { useLocale, useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { LOCALES, isLocale, localeCookie } from "./locale";

/** Native-language names, so a user can always find their language whatever the current one is. */
const NAMES: Record<(typeof LOCALES)[number], string> = { en: "English", ar: "العربية" };

export function LanguageSwitcher({ className }: { className?: string }) {
  const locale = useLocale();
  const t = useTranslations("language");
  const router = useRouter();
  return (
    <label className={className}>
      <span className="sr-only">{t("label")}</span>
      <select
        value={locale}
        onChange={(event) => {
          if (!isLocale(event.target.value)) return;
          document.cookie = localeCookie(event.target.value);
          router.refresh();
        }}
        className="h-9 rounded-md border border-input bg-background px-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        {LOCALES.map((value) => (
          <option key={value} value={value} lang={value}>
            {NAMES[value]}
          </option>
        ))}
      </select>
    </label>
  );
}
